import React, {useContext, useEffect, useState} from 'react';
import {fetchData} from "./functions";
import {NoteBookReportContext} from "./NoteBookReportContext";
import "./secondFilterTable.scss";
import numericFunction from "../../../utils/NumericFunction";
import objectDataHolder from "../../Hooks/ObjectDataHolder";

function SecondFilterTable(props) {

  /*
  برنامه نویس عزیز و دوست داشتنی
  ما چون توی این کامپوننت فیلتر داریم  و این کامپوننت هم توی  هر تبی که کاربر انتخاب کنه تکرار میشه
  من اومدم دیتای نمایشی رو با پراپز فرستاد تا بتونم فیلتر کنم.
  پس ما با دیتا کار نداریم و مهم مقدار دیتا1 هست که داده هایی که بک داده توش داره ذخیره میشه
   */
  const helper = useContext(NoteBookReportContext)
  const setData = helper.setData
  const data = helper.data

  const selectedTab = props.selectedTab
  const data1 = props.data1


   


  const [disableStatus, setDisableStatus] = useState(false)

  const [filteredData, setFilteredData] = useState(data1)


  // useEffect(() => {
  //   setFilteredData(data1)
  // }, [data1]);


  const [filterInput, setFilterInput] = objectDataHolder({accountCode: "", accountName: ""})


  const clickHandler = async (e, row) => {

    const isChecked = e.target.checked;
    let prevFilter = [...data.prevFilter]

    if (isChecked) {
      prevFilter.push(row)

    } else {
      prevFilter = prevFilter.filter(thisRow => thisRow.accountCode !== row.accountCode)
    }
    console.log(prevFilter)
    setData({prevFilter})
    setDisableStatus(true)

    fetchData({data: {prevFilter, level: data.level}, setData}).then(() => {

      setDisableStatus(false)
    })

  }
  const handleChangeCode = (e) => {
    setFilterInput({accountCode: e.target.value})
  }
  const handleChangeName = (e) => {
    setFilterInput({accountName: e.target.value})
  }

  useEffect(() => {


    let tempData = [...data1] || [];
    if (filterInput.accountCode !== "") tempData = tempData.filter(v => v.accountCode.includes(filterInput.accountCode))
    if (filterInput.accountName !== "") tempData = tempData.filter(v => v.accountName.includes(filterInput.accountName))

    setFilteredData(tempData)


  }, [data1,filterInput.accountName, filterInput.accountCode]);


  try {
    return (<div className={"second__filter_table"}>
      <div className={"w-100 position-relative "}>
        <div className={"header__filter__table"}>
          <ul className={" w-100 d-flex justify-content-around bg__color__F1F1F1 px-0"}>
            <li className={"w-50 text-center"}>کد</li>
            <li className={"w-50 text-center"}>عنوان</li>
          </ul>
        </div>


        <div style={{
          position: "relative", height: '50vh', border: "1px solid #B9B9B9",
        }}
        >
          <div className={"my__hr"}
               style={{
                 width: '1px',
                 height: '50vh',
                 overflow: "hidden",
                 background: "#B9B9B9",
                 position: "absolute",
                 left: "50%"

               }}></div>


          <div className={"table__body"}
               style={{
                 height: "50vh", overflow: "scroll",

               }}
          >
            <div>

              <ul className={"w__400px d-flex justify-content-around p-0"}>
                <li><input placeholder={"فیلتر..."} value={filterInput.accountCode} onChange={handleChangeCode}
                           className={"px-1"} type="text"/></li>
                <li><input placeholder={"فیلتر..."} value={filterInput.accountName} onChange={handleChangeName}
                           className={"px-1"} type="text"/></li>
              </ul>
              {filteredData?.map((row, index) => {
                // const isChecked = !!data.prevFilter.find(v => JSON.stringify(v) === JSON.stringify(row))
                const isChecked = !!data.prevFilter.find(v => v.accountCode === row.accountCode)

                return <ul key={index} className={"w__400px d-flex justify-content-around p-0"}>
                  <li className={"pe-3 w-50"}>
                    <div className={"checkbox-side"}>
                      <input id={row.accountCode} type="checkbox"

                             disabled={disableStatus}
                             checked={isChecked}
                             onChange={(e) => clickHandler(e, row)}
                      />
                      <label htmlFor={row.accountCode}

                      >{numericFunction.e2p(row.accountCode)}</label>
                    </div>

                  </li>
                  <li className={" w-50"}>{row.accountName}</li>
                </ul>

              })}
            </div>
          </div>
        </div>

      </div>
    </div>);

  } catch (error) {
    return <>{error.toString()}</>
  }
}

export default SecondFilterTable;